import type { RideSubsegment } from '@engage/api-v2-models/generated/RideSubsegment';
import type { ApiClassDetails } from '@engage/classes/models';
import type { MemberInfo } from '@engage/members/models/Member';
import type { Playlist, RadioData } from '@engage/video-ui/models';

export type ApiSegment = {
  id: string;
  startTimeOffset: number;
  length: number;
  name: string;
  metricsType: string;
  intensityInMets: number;
  iconName: string;
  iconSlug: string;
  iconUrl: string;
  subsegmentsV2?: Array<RideSubsegment>;
};

export type ApiSegments = {
  segmentList?: ApiSegment[];
};

export type Averages = {
  averageTotalWork?: number;
  averageDistance?: number;
  averageElevation?: number;
  averageCalories?: number;
  averageAvgPower?: number;
  averageAvgIncline?: number;
  averageAvgSpeed?: number;
  averageAvgPace?: number;
  averageAvgCadence?: number;
  averageAvgResistance?: number;
  totalHeartRateZoneDurations?: {
    heartRateZ1Duration?: number;
    heartRateZ2Duration?: number;
    heartRateZ3Duration?: number;
    heartRateZ4Duration?: number;
    heartRateZ5Duration?: number;
  };
  averageEffortScore?: number;
  avgFollowAlongScoreBySubsegmentId?: Array<{
    subsegmentId?: string;
    avgScore?: number;
  }>;
  classAvgFollowAlongScore?: number;
};

type ApiLanguageSelectionBase = {
  locale: string; // de-DE, en-US, etc.
  displayName: string;
  isSelected: boolean;
};

export const ApiLanguageSelectionType = {
  ORIGINAL: 'original',
  STUDIO_DUBBED: 'studio_dubbed',
  AI_DUBBED: 'ai_dubbed',
} as const;

export type ApiLanguageSelectionType =
  typeof ApiLanguageSelectionType[keyof typeof ApiLanguageSelectionType];

type ApiLanguageSelectionOriginal = ApiLanguageSelectionBase & {
  type: typeof ApiLanguageSelectionType.ORIGINAL;
  streamSlug: null;
};

type ApiLanguageSelectionDubbed = ApiLanguageSelectionBase & {
  type:
    | typeof ApiLanguageSelectionType.AI_DUBBED
    | typeof ApiLanguageSelectionType.STUDIO_DUBBED;
  streamSlug: string;
};

type ApiLanguageSelection = ApiLanguageSelectionOriginal | ApiLanguageSelectionDubbed;

export type ApiClassDetail = {
  playlist: Playlist;
  radioData?: RadioData;
  segments?: ApiSegments;
  ride: ApiClassDetails;
  averages: Averages;
  sampledTopTags: string[];
  languageSelections?: ApiLanguageSelection[];
  dubbedLanguages?: string[];
};

export type ApiFriendsResponse = {
  data: {
    user: MemberInfo;
  }[];
};
